import { useDrag } from '@use-gesture/react';

const shouldIgnoreTarget = (target) => {
  if (!target || typeof target.closest !== 'function') return false;
  // Don't fight the data grid: it needs horizontal scrolling on mobile.
  if (target.closest('.MuiDataGrid-root')) return true;
  // Don't capture gestures starting on interactive controls.
  if (target.closest('input, textarea, select, button, a, [role="button"], [data-gesture-ignore="true"]')) return true;
  return false;
};

export function useSwipeGestures({ enabled = true, onSwipeLeft, onSwipeRight, thresholdPx = 80 } = {}) {
  return useDrag(
    ({ active, movement: [mx, my], last, event, cancel }) => {
      if (!enabled) return;
      if (shouldIgnoreTarget(event?.target)) {
        cancel?.();
        return;
      }

      // Only handle when it's predominantly horizontal.
      const absX = Math.abs(mx);
      const absY = Math.abs(my);
      if (active && absY > absX) return;
      if (!last) return;

      if (absX < thresholdPx || absX < absY * 1.2) return;

      if (mx < 0) onSwipeLeft?.();
      if (mx > 0) onSwipeRight?.();
    },
    {
      axis: 'x',
      filterTaps: true,
      pointer: { touch: true },
      eventOptions: { passive: true },
    }
  );
}



